import { Component, OnInit } from '@angular/core';
import { AchatService } from '../../../../../../services/achat/achat.service';

@Component({
    selector: 'app-brouillon-retour-frns',
    templateUrl: './brouillon-retour-frns.component.html',
    styleUrls: ['./brouillon-retour-frns.component.scss']
})
export class BrouillonRetourFrnsComponent implements OnInit {
    constructor(private achatService: AchatService) {}

    ngOnInit(): void {
        this.achatService.filterRetourFournisseurByStatus('Brouillon');
    }
}
